import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from "@angular/core";
import { TRADABLES_TYPE } from "@helpers/constants";
import { Fiat, Offer } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { CoreModule } from "@modules/core/core.module";
import { Web3Facade } from "@modules/web3/+state/web3.facade";
import { WEB3_FEE_BENEFFIT_FLOW } from "@modules/web3/interface/web3.benefit.ui.interface";
import { VisionFeeTransDetailComponent } from "@modules/web3/ui/vision-fee-trans-detail/vision-fee-trans-detail.component";
import { EMPTY, Observable } from "rxjs";

@Component({
	selector: "fee-transparency-trade-data-ui",
	imports: [CoreModule, VisionFeeTransDetailComponent],
	standalone: true,
	templateUrl: "./fee-transparency-data.component.html",
	styleUrl: "./fee-transparency-data.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeeTransparencyTradeDataComponent implements OnInit {
	private web3facade = inject(Web3Facade);

	@Input() data: Offer;
	@Input() fiat: Fiat;
	@Input() tradable: Tradable;
	@Input() isTaxable = false;
	@Input() isMtBuy = false;
	@Input() mtBuyAmount: string = "";

	vsnFeeBenefitFF$: Observable<boolean> = EMPTY;

	readonly TRADABLES_TYPE = TRADABLES_TYPE;

	isError: boolean = false;
	isSell: boolean = false;

	ngOnInit(): void {
		this.checkDataAndTradeType();

		//TODO: is this FF necesary?
		//VSN fee benefit FF
		let feeBenefitFlowType = WEB3_FEE_BENEFFIT_FLOW.marketOrderBuy;

		if (this.data.getType() === TRADE_TYPE.SELL) {
			feeBenefitFlowType = WEB3_FEE_BENEFFIT_FLOW.marketOrderSell;
		}

		this.vsnFeeBenefitFF$ = this.web3facade.getVSNFeeBenefitFF(feeBenefitFlowType);
	}

	private checkDataAndTradeType(): void {
		this.isError = Object.values(this.data?.getFee()?.fee).includes(undefined);
		this.isSell = this.data.getType() === TRADE_TYPE.SELL;
	}
}
